<template>
    <div class="flex flex-none items-center justify-center flex-col lg:flex-row mb-10 lg:mb-0 lg:-mr-4 pl-1">
        <ul class="flex flex-col items-center justify-center lg:flex-row mb-0">
            <nav-link
                label="Dashboard"
                :href="routes.dashboard"
                :active="current == 'broker.dashboard'"
            />

            <nav-link
                label="Contacts"
                :href="routes.contacts"
                :active="current.indexOf('broker.contacts') > -1"
            />

            <nav-link
                label="Settings"
                :href="routes.settings"
                :active="current.indexOf('broker.settings') > -1"
            />

            <nav-link
                v-if="user && user.is_tenant_admin"
                label="Admin"
                :href="routes.admin"
                :active="current.indexOf('broker.admin') > -1"
            />

            <nav-link
                label="How To"
                :href="routes.how_to"
                :active="current.indexOf('how-to') > -1"
            />

            <nav-link
                v-if="!user || !user.is_tenant_admin"
                label="Contact Us"
                href="mailto:support@contract2close.com"
            />

            <nav-link
                label="Log Out"
                :href="routes.logout"
            />
        </ul>
    </div>
</template>

<script>
import NavLink from './nav-link.vue';

export default {
    components: {
        NavLink,
    },

    props: {
        current: {},
        routes: {},
        user: {},
    },
}
</script>
